import { useState } from 'react'
import { Header, HeaderLogo, HeaderActions } from '@sainsburys-tech/luna-header'
import { Home, Account, InfoCircle } from '@sainsburys-tech/luna-icons';
import './index.scss';
import { NavLink } from "react-router-dom"
import { Card } from '@sainsburys-tech/luna-card'
import logo from '../../../../Assets/logo/logo.svg'


import { FC } from 'react';
import { useMsal } from '@azure/msal-react';
import { LogoutProps } from '../../../../CustomTypes/Filters';
import ConfirmModal from '../../../Confirm';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../../../authConfig';

const TopHeader: FC = () => {
    const [active, setActive] = useState("dropdown-content")
    const [confirmModal, setConfirmModal] = useState<LogoutProps>()
    const [isConfirmModal, setIsConfirmModal] = useState(false)

    const { instance } = useMsal();

    const account = instance.getActiveAccount();

    const logout = () => {
        const logoutProps: LogoutProps = {
            actionType: 'logout',
            message: 'Do you wish to logout?',
            title: 'Confirm Logout',
            actionToDisplay: 'Confirm'
        };
        setConfirmModal(logoutProps)
        setIsConfirmModal(true)
    }
    const dialogHandler = async (action: string) => {
        setIsConfirmModal(false)
        if (action === 'confirm') {
            const myMsal = new PublicClientApplication(msalConfig);
            const logoutRequest = {
                account: myMsal.getAccountByHomeId(account?.homeAccountId || ""),
                mainWindowRedirectUri: "/"
            }
            await myMsal.logoutPopup(logoutRequest);
        }
    }
    const getInitials = (name: string | undefined) => {
        if (name !== "" && name !== undefined) {
            let nameArray = name.split(' ')
            if (nameArray.length >= 2) {
                return `${account?.name?.split(' ')[0].charAt(0)}${account?.name?.split(' ')[1].charAt(0)}`
            }
            return name
        }
    }

    const onClick = () => {
        setActive("dropdown-content dropdown-click")
    }

    const onMouseOut = () => {
        setActive("dropdown-content")
    }

    return (
        <>
            {/* <SiteLayout> */}
            {isConfirmModal && < ConfirmModal
                title={confirmModal?.title || ""}
                message={confirmModal?.message || ""}
                dialogHandler={dialogHandler} />}
            <Header style={{ zIndex: 5 }} >
                <HeaderLogo>
                    <NavLink to="/" className="header-item__link remove-link">
                        {/* <p className="header-item__link logo-font-size">Origin Pick</p>*/}
                        <img className="logo" src={logo} alt="logo" />
                    </NavLink>
                </HeaderLogo>
                <HeaderActions align="right" label="Basket and account">
                    <NavLink to="/" className="header-item__link remove-link">
                        <Home />
                        <span className="ln-u-visually-hidden">Home</span>
                    </NavLink>
                    <a href="#info">
                        <InfoCircle />
                        <span className="ln-u-visually-hidden">InfoCircle</span>
                    </a>
                    <Card>
                        <div className="dropdown" onMouseOut={onMouseOut}>
                            <button className="dropbtn ln-c-header__item" onClick={onClick}>{getInitials(account?.name)}<Account /></button>
                            <div className={active}>
                                <span className='no-cursor'><b>{account?.name} ({account?.username.toLocaleLowerCase()})</b></span>
                                <span onClick={logout}><b>Sign Out</b></span>
                            </div>
                        </div>
                    </Card>
                </HeaderActions>
            </Header>
        </>
    )
}

export default TopHeader;